import { createHashRouter, Navigate } from 'react-router-dom';
import AdminRoutesGuard from './AdminRoutesGuard';

import Verify from '../pages/Verify/Verify';

import Builder from '../pages/Builder/Builder';
import BookPage from '../pages/BookPage/BookPage';
import BookFlip from '../pages/BookFlip/BookFlip';
import BookList from '../pages/BookList/BookList';
import BookPurchase from '../pages/BookPurchase/Purchase';
import About from '../pages/About/About';
import Help from '../pages/Help/Help';
import Pricing from '../pages/Pricing/Pricing';
import Profile from '../pages/Profile/Profile';
import Credit from '../pages/Credit/Credit';

import Admin from '../pages/Admin/Admin';
import Coupons from '../pages/Admin/Coupon/Coupon';
import Dashboard from '../pages/Admin/Dashboard';
import ImpersonateBridge from '../pages/Admin/ImpersonateBridge';

import AdminSignup from '../pages/Admin/AdminSignup';
import UserRouteGuard, { BrowserPopupComponent } from './UserRouteGuard';
import ForgotPassword from '../pages/User/ForgotPassword';
import ResetPassword from '../pages/User/ResetPassword';
import OrderHistory from '../pages/OrderHistory/OrderHistory';
import Payments from '../pages/PaymentHistory/PaymentHistory';
import MyPlans from '../pages/MyPlans/MyPlans';
import Debug from '../pages/Debug/Debug';
import React from 'react';
import RedirectRoute from '../components/Redirect/Redirect.route';
import ThankYouMessage from '../pages/BookPurchase/components/ThankYouMessage';
import Teacher from '../pages/Teacher/Teacher';
import TeacherClassroomLibrary from '../pages/Teacher/pages/TeacherClassroomLibrary';
import TeacherClassroomStudents from '../pages/Teacher/pages/TeacherClassroomStudents';
import TeacherClassroomSettings from '../pages/Teacher/pages/TeacherClassroomSettings';
import TeacherClassroomDashboard from '../pages/Teacher/pages/TeacherClassroomDashboard';
import TeacherOnboarding, { TeacherOnboardingPagesEnum } from '../pages/Teacher/TeacherOnboarding';
import OnboardingSchoolInfo from '../pages/Teacher/components/OnboardingSchoolInfo';
import OnboardingClassInfo from '../pages/Teacher/components/OnboardingClassInfo';
import OnboardingHowDidYouFindUs from '../pages/Teacher/components/OnboardingHowDidYouFindUs';
import { AuthSignUp, GrowUp, LocationSelection, ParentPermission, StudentAuth } from '../pages/Auth';
import Auth from '../pages/Auth/Auth';
import CleverCallback from '../pages/Auth/CleverCallback';
import GoogleClassroomCallback from '../pages/Auth/GoogleClassroomCallback';
import StudentAuthContainer from '../pages/Auth/StudentAuthContainer';
import Respond, { RespondSuccess } from '../pages/Respond';
import SignUpOptions from '../pages/Auth/SignUpOptions';
import ParentChildConfirmation from '../pages/Teacher/components/ParentChildConfirmation';
import CleverPopupCallback from '../pages/Auth/CleverPopupCallback';
import GeneralSignUpContainer from '../pages/Auth/user/GeneralSignUp.container';
import GeneralLoginContainer from '../pages/Auth/user/GeneralLogin.container';
import GeneralSignUpOptions from '../pages/Auth/user/GeneralSignUpOptions';
import MainFooterContainer from '../components/Common/MainFooterContainer';

const RouterMain = createHashRouter([
  {
    children: [
      {
        path: '/',
        element: (
          <BrowserPopupComponent>
            {' '}
            <Builder />{' '}
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/respond',
        element: (
          <BrowserPopupComponent ignoreAuthorisationGuard={true} ignorePopup={true}>
            <Respond />
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/respond/success',
        element: (
          <BrowserPopupComponent ignorePopup={true} ignoreAuthorisationGuard={true}>
            <RespondSuccess preorder={true} />
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/respond/confirm',
        element: (
          <BrowserPopupComponent ignorePopup={true} ignoreAuthorisationGuard={true}>
            <RespondSuccess preorder={false} />
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/auth/teacher/login',
        element: (
          <BrowserPopupComponent ignorePopup={true} ignoreAuthorisationGuard={true}>
            <MainFooterContainer>
              <Auth />
            </MainFooterContainer>
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/auth/clever/callback',
        element: (
          <BrowserPopupComponent ignorePopup={true} ignoreAuthorisationGuard={true}>
            <CleverCallback />
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/auth/clever/popup-callback',
        element: (
          <BrowserPopupComponent ignorePopup={true} ignoreAuthorisationGuard={true}>
            <CleverPopupCallback />
          </BrowserPopupComponent>
        ),
      },
      // {
      //   path: '/auth/google-classroom/callback',
      //   element: (
      //     <BrowserPopupComponent ignorePopup={true}>
      //       <GoogleClassroomCallback />
      //     </BrowserPopupComponent>
      //   ),
      // },
      {
        path: '/auth/google-classroom/popup-callback',
        element: (
          <BrowserPopupComponent ignorePopup={true}>
            <GoogleClassroomCallback />
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/auth/teacher',
        element: (
          <BrowserPopupComponent ignorePopup={true} ignoreAuthorisationGuard={true}>
            <MainFooterContainer>
              <SignUpOptions />
            </MainFooterContainer>
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/auth/teacher/signup',
        element: (
          <BrowserPopupComponent ignoreAuthorisationGuard={true}>
            <MainFooterContainer>
              <AuthSignUp />
            </MainFooterContainer>
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/auth/student',
        element: (
          <BrowserPopupComponent ignoreAuthorisationGuard={true}>
            <MainFooterContainer>
              <LocationSelection />
            </MainFooterContainer>
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/auth/student/login',
        element: (
          <BrowserPopupComponent ignorePopup={true} ignoreAuthorisationGuard={true}>
            <MainFooterContainer>
              <StudentAuth />
            </MainFooterContainer>
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/auth/student/growup',
        element: (
          <BrowserPopupComponent ignoreAuthorisationGuard={true}>
            <MainFooterContainer>
              <StudentAuthContainer>
                <GrowUp />
              </StudentAuthContainer>
            </MainFooterContainer>
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/auth/student/parent',
        element: (
          <BrowserPopupComponent ignoreAuthorisationGuard={true}>
            <MainFooterContainer>
              <StudentAuthContainer>
                <ParentPermission />
              </StudentAuthContainer>
            </MainFooterContainer>
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/auth',
        element: (
          <BrowserPopupComponent>
            {' '}
            <MainFooterContainer>
              <GeneralSignUpOptions />
            </MainFooterContainer>{' '}
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/signUp',
        element: (
          <BrowserPopupComponent ignoreAuthorisationGuard={true}>
            {' '}
            <MainFooterContainer>
              <GeneralSignUpContainer />
            </MainFooterContainer>{' '}
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/signin',
        element: (
          <BrowserPopupComponent ignoreAuthorisationGuard={true}>
            {' '}
            <MainFooterContainer>
              <GeneralLoginContainer />
            </MainFooterContainer>{' '}
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/redirect',
        element: (
          <BrowserPopupComponent ignoreAuthorisationGuard={true}>
            {' '}
            <RedirectRoute defaultLoc="/" />{' '}
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/purchase/success',
        element: (
          <BrowserPopupComponent ignoreAuthorisationGuard={true}>
            <ThankYouMessage />
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/story/bookflip/:bookId',
        element: (
          <BrowserPopupComponent ignoreAuthorisationGuard={true}>
            <BookFlip isShare={true} />
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/story/bookflip/:bookId/confirmation',
        element: (
          <BrowserPopupComponent>
            <ParentChildConfirmation></ParentChildConfirmation>
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/book/purchase/:bookId',
        element: (
          <BrowserPopupComponent ignoreAuthorisationGuard={true}>
            <BookPurchase isShare={true} />
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/builder/:newBook',
        element: (
          <BrowserPopupComponent>
            {' '}
            <Builder />{' '}
          </BrowserPopupComponent>
        ),
      },
      {
        path: '/verify/:token',
        element: <Verify />,
      },
      {
        path: '/forgot-password',
        element: <ForgotPassword />,
      },
      {
        path: '/reset-password/:email/:token',
        element: <ResetPassword />,
      },
      {
        path: '/admin',
        element: <Admin />,
      },
      {
        path: '/admin/impersonate',
        element: <ImpersonateBridge />,
      },
      {
        element: <UserRouteGuard />,
        children: [
          {
            path: '/books/:bookId',
            element: <BookPage />,
          },
          {
            path: '/bookflip/:bookId',
            element: (
              <BrowserPopupComponent>
                <BookFlip />
              </BrowserPopupComponent>
            ),
          },
          {
            path: '/booklist',
            element: <BookList />,
          },
          {
            path: '/bookpurchase/:bookId',
            element: (
              <BrowserPopupComponent>
                <BookPurchase />
              </BrowserPopupComponent>
            ),
          },
          {
            path: '/updateProfile',
            element: (
              <BrowserPopupComponent>
                <Profile />
              </BrowserPopupComponent>
            ),
          },
          {
            path: '/myPlans',
            element: (
              <BrowserPopupComponent>
                <MyPlans />
              </BrowserPopupComponent>
            ),
          },
          {
            path: '/pricing',
            element: <Pricing />,
          },
          {
            path: '/about',
            element: <About />,
          },
          {
            path: '/help',
            element: <Help />,
          },
          {
            path: '/library',
            element: (
              <BrowserPopupComponent>
                <Debug />
              </BrowserPopupComponent>
            ),
          },
          {
            path: '/classroom/dashboard',
            element: (
              <BrowserPopupComponent>
                <Teacher>
                  <TeacherClassroomDashboard />
                </Teacher>
              </BrowserPopupComponent>
            ),
          },
          {
            path: '/classroom/library',
            element: (
              <BrowserPopupComponent>
                <Teacher>
                  <TeacherClassroomLibrary></TeacherClassroomLibrary>
                </Teacher>
              </BrowserPopupComponent>
            ),
          },
          {
            path: '/classroom/students',
            element: (
              <BrowserPopupComponent>
                <Teacher>
                  <TeacherClassroomStudents></TeacherClassroomStudents>
                </Teacher>
              </BrowserPopupComponent>
            ),
          },
          {
            path: '/classroom/settings',
            element: (
              <BrowserPopupComponent>
                <Teacher>
                  <TeacherClassroomSettings></TeacherClassroomSettings>
                </Teacher>
              </BrowserPopupComponent>
            ),
          },
          // {
          //   path: TeacherOnboardingPagesEnum.Onboarding,
          //   element: (
          //     <BrowserPopupComponent>
          //       <TeacherOnboarding>
          //         <OnboardingOptions></OnboardingOptions>
          //       </TeacherOnboarding>
          //     </BrowserPopupComponent>
          //   ),
          // },
          // {
          //   path: TeacherOnboardingPagesEnum.OnboardingQuestionary,
          //   element: (
          //     <BrowserPopupComponent>
          //       <TeacherOnboarding>
          //         <OnboardingQuestionary></OnboardingQuestionary>
          //       </TeacherOnboarding>
          //     </BrowserPopupComponent>
          //   ),
          // },
          // {
          //   path: TeacherOnboardingPagesEnum.OnboardingShippingAddress,
          //   element: (
          //     <BrowserPopupComponent>
          //       <TeacherOnboarding>
          //         <OnboardingShippingAddress></OnboardingShippingAddress>
          //       </TeacherOnboarding>
          //     </BrowserPopupComponent>
          //   ),
          // },
          // {
          //   path: TeacherOnboardingPagesEnum.OnboardingTimeline,
          //   element: (
          //     <BrowserPopupComponent>
          //       <TeacherOnboarding>
          //         <OnboardingTimeline></OnboardingTimeline>
          //       </TeacherOnboarding>
          //     </BrowserPopupComponent>
          //   ),
          // },
          {
            path: TeacherOnboardingPagesEnum.OnboardingVideo,
            element: <Navigate to={TeacherOnboardingPagesEnum.OnboardingSchoolInfo} replace />,
          },
          {
            path: TeacherOnboardingPagesEnum.OnboardingSchoolInfo,
            element: (
              <BrowserPopupComponent>
                <TeacherOnboarding>
                  <OnboardingSchoolInfo />
                </TeacherOnboarding>
              </BrowserPopupComponent>
            ),
          },
          {
            path: TeacherOnboardingPagesEnum.OnboardingClassInfo,
            element: (
              <BrowserPopupComponent>
                <TeacherOnboarding>
                  <OnboardingClassInfo />
                </TeacherOnboarding>
              </BrowserPopupComponent>
            ),
          },
          {
            path: TeacherOnboardingPagesEnum.OnboardingHowDidYouFindUs,
            element: (
              <BrowserPopupComponent>
                <TeacherOnboarding>
                  <OnboardingHowDidYouFindUs />
                </TeacherOnboarding>
              </BrowserPopupComponent>
            ),
          },
          {
            path: '/ImageTokens',
            element: (
              <BrowserPopupComponent>
                <Credit />
              </BrowserPopupComponent>
            ),
          },
          {
            path: '/OrderHistory',
            element: (
              <BrowserPopupComponent>
                <OrderHistory />
              </BrowserPopupComponent>
            ),
          },
          {
            path: '/Payments',
            element: (
              <BrowserPopupComponent>
                <Payments />
              </BrowserPopupComponent>
            ),
          },
        ],
      },
      {
        element: <AdminRoutesGuard />,
        children: [
          {
            path: '/admin/signup',
            element: <AdminSignup />,
          },
          {
            path: '/admin/dashboard',
            element: <Dashboard />,
          },
          {
            path: '/admin/coupon',
            element: <Coupons />,
          },
        ],
      },
      {
        path: '/not-found',
        element: <div>Page Not found</div>,
      },
      {
        path: '*',
        element: <div>Page Not found</div>,
      },
    ],
  },
  {
    path: '/',
    element: <Navigate to={'/'} replace />,
  },
]);
export default RouterMain;
